<template>
    <div class="bg-white mt-3 p-3 activity-type-create col-12">
        <!-- <b-col cols="12" class=""> -->
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button id="cancel-master-bank-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ title }}</span>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">



                <b-row>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('bank_name') }}</strong></label>
                        <b-form-input id="input-bank-name" type="text" class="form-control" v-model="model.bank_name"
                            :placeholder="$translate('enter_bank_name')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('bank_code') }}</strong></label>
                        <b-form-input id="input-bank-code" type="text" class="form-control" v-model="model.bank_code"
                            :placeholder="$translate('enter_bank_code')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('external_gl_code') }}</strong></label>
                        <b-form-input id="input-external_gl_code" type="text" class="form-control" v-model="model.external_gl_code"
                            :placeholder="$translate('enter_external_gl_code')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('description') }} </strong></label>
                        <b-form-textarea id="input-description" v-model="model.description"
                            :placeholder="$translate('enter_description')" trim></b-form-textarea>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <div class="d-flex align-items-center">
                            <div class="form-check me-3">
                                <label class="form-check-label">
                                    <input type="checkbox" id="input-is_default" v-model="model.is_default" name="input-is_default"
                                        :value="1" :unchecked-value="0" />
                                    <i class="input-helper"></i>
                                </label>
                            </div>
                            <label id="is_default-group" for="input-is_default" class="mb-1 ms-2">
                                <strong>{{ $translate('default') }}</strong>
                            </label>    
                        </div>
                    </b-col>

                </b-row>

                <b-col md="12" class="mb-2 mt-3 text-center">
                    <!-- <b-button v-if="hasPermissionCreate && !model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button v-if="hasPermissionUpdate && model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button v-if="model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button> -->
                    
                    <b-button id="create-master-bank-btn" v-if="hasPermissionCreate && !model.id" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                        :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button  id="update-master-bank-btn" v-if="hasPermissionUpdate && model.id" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                        :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button  id="delete-master-bank-btn" v-if="model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2" variant="delete-button">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button  id="cancel-master-bank-form-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button>
                </b-col>

            </b-form>
        </b-overlay>
    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'MasterBank-ViewItem',
    mixins: [permissionsMixins, popupMixins],
    data() {
        return {
            componentName: 'Master Banks',
            flow_options: [
                { value: '1', text: 'Inbound' },
                { value: '0', text: 'Outbound' },
            ],
            entity_options: [
                { value: '0', text: 'Customer' },
                { value: '1', text: 'Officer' },
            ],
            model: {
                id: 0,
                banke_name: null,
                bank_code: null,
                external_gl_code: null,
                description : null,
                is_default: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    
    props: ['item'],
    computed: {
        title() { return this.$translate('master_bank') },
        
        isUpdateMode() {
            return this.model.id > 0
        },

        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        
       
    },
    watch: {
      
        'model.name': function(val){
            if(val != ""){
                this.model.name =  val.replace(/[^a-zA-Z ]/, '')
                this.model.name =  val.replace(/\s{2,}/g, ' ')
            }
        }
    },
    mounted() {
   
        if (this.item.id) {
            this.model = { ...this.item }
          
        }
      
    },
    created() {
        // this.$store.dispatch('orderTemplate/fetchAll')
        // this.$store.dispatch('checkoffTemplates/fetchAll',{})
        // this.$store.dispatch('transactionType/fetchAll')
        // this.$store.dispatch('orderCategory/fetchAll')
        // this.$store.dispatch('users/fetchAll')
        // this.$store.dispatch('interactionType/fetchAll')
    },
    methods: {
        validateInput() {
            // Replace any characters that are not letters or space with an empty string
            this.model.name = this.model.name.replace(/[^a-zA-Z\s]/g, '');
            
            // Remove extra spaces
            this.model.name = this.model.name.replace(/\s+/g, ' ');

            // Limit to a single space between words
            this.model.name = this.model.name.replace(/\s\s+/g, ' ');
        },
        cancel() {
            this.$emit('cancel')
        },
        deleteItem() {
            // Initializing key variables
            // console.log('Attempt to delete')
            const model = { ...this.model }
             const path = 'masterBank/delete'
            const action = model.id ? 'update' : 'create'

            // // Generate and display confirmation prompt
            const title = this.$translate('delete_activity_type')
            const message = `${this.$translate('delete_note')} ${model.id}?`
            // const errorMsg = this.$translate('Unable_to_delete_Activity_Type')
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
            // this.$emit(
            //     'delete-item',
            //     title,
            //     message,
            //     model.id,
            //     () => {
            //         this.$emit('success', this.$translate('deleted'))
            //     },
            //     path,
            //     errorMsg
            // )
        },

        createOrUpdate() {
            this.loading = true
          
            const { model, paymentAttachments: attachments } = this
          
            const paymentModel = { ...model, attachments }
            // const model = { ...this.model }
            console.log('model', paymentModel)
            
            // allow only letters and single space between words in activity type name
            // let pattern = new RegExp(/^\s*([a-zA-Z]+\s)*[a-zA-Z]+\s*$/)
            // if(!pattern.test(model.name)){
            //     this.doToast(this.$translate('error'), this.$translate('invalid_name'), 'danger')
            //     this.loading = false
            //     return false
            // }
            const path = model.id ? 'masterBank/update' : 'masterBank/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, paymentModel)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? this.$translate('updated') : this.$translate('created')
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log("error", error.message)
                            this.doToast(this.$translate('error'), error.message, 'danger')
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

    
    },
}
</script>
